export const yesNo = [
  { label: "Si", value: true },
  { label: "No", value: false }
]
